import {ModalCloseButton} from '@chakra-ui/react';

export default function ChakraModalCloseButton({...props}) {
    return <ModalCloseButton {...props} />;
}
